import React, { useState, useEffect } from 'react'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'
import { useDataManagement } from '../../Hooks/useDataManagement'
import { FormGroup, Label } from 'reactstrap'

import { DataManagementGrid } from '../Common'
import { parameterColumns } from '../../Data/ParameterManagement/ParameterListData'
import { getAllData, deleteIdData, getDataWithType } from '../../lib/parameters'
import { ParameterTypeSelect } from '../Common/FormSelects'

const AdminParameterList = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()
	const [type, setType] = useState('All')
	const [filteredData, setFilteredData] = useState([])

	const { data, loading, searchQuery, setSearchQuery, handleDelete } = useDataManagement(getAllData, deleteIdData)

	const searchFields = ['id', 'type', 'pname', 'order']

	// Filter data based on type selection
	useEffect(() => {
		const filterData = async () => {
			if (type === 'All') {
				setFilteredData(data)
			} else {
				try {
					const typeData = await getDataWithType(type)
					setFilteredData(typeData)
				} catch (error) {
					console.error('Error fetching data by type:', error)
					setFilteredData(data)
				}
			}
		}
		filterData()
	}, [type, data])

	return (
		<DataManagementGrid
			title="Parameters"
			subTitle="Manage system parameters"
			breadcrumbTitle="Parameters"
			breadcrumbMainTitle="Parameters"
			columns={parameterColumns}
			data={filteredData}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search parameters..."
			createButtonText="Create New Parameter"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/parameters/create/${layout}`}
			onDelete={handleDelete}
			searchFields={searchFields}
			noDataMessage="No parameters found"
			customHeaderComponent={
				<div className="d-flex align-items-center gap-3">
					<div style={{ width: '300px' }}>
						<FormGroup className="mb-0">
							<Label className="form-control-label">Filter by Type</Label>
							<ParameterTypeSelect value={type} setValue={setType} page="List" />
						</FormGroup>
					</div>
				</div>
			}
		/>
	)
}

export { AdminParameterList }
